module.exports = __webpack_public_path__ + "static/media/newsThumbNailSample.ff5a59cb.png";